import { assign, setup } from 'xstate';

import { TripLegType } from '@/data/models/reservation.model';

import { DEFAULT_TRIP_TYPE } from '../schema/reservationForm.schema';

export type TripTypeContext = { value: TripLegType };

export type TripTypeValue = TripLegType;

export type TripTypeEvent =
  | { type: 'CHANGE'; value: TripLegType }
  | { type: 'RESET' }
  | { type: 'BLUR' }
  | { type: 'FOCUS' };

export const tripTypeMachine = setup({
  types: {
    context: {} as TripTypeContext,
    events: {} as TripTypeEvent,
  },
}).createMachine({
  id: 'tripType',
  context: { value: DEFAULT_TRIP_TYPE },
  initial: 'idle',
  states: {
    idle: {
      on: {
        FOCUS: { target: 'focused' },
        CHANGE: {
          actions: assign({
            value: ({ event }) =>
              event.type === 'CHANGE' ? event.value : DEFAULT_TRIP_TYPE,
          }),
        },
      },
    },
    focused: {
      on: {
        BLUR: { target: 'idle' },
        CHANGE: {
          actions: assign({
            value: ({ event }) =>
              event.type === 'CHANGE' ? event.value : DEFAULT_TRIP_TYPE,
          }),
        },
      },
    },
  },
  on: {
    RESET: {
      target: '.idle',
      actions: assign({ value: DEFAULT_TRIP_TYPE }),
    },
  },
});
